import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { color } from "../../../Theme";
import { FormHelperText, Box } from "@mui/material";

export interface selectProps {
  className?: string;
  id?: string;
  value?: any;
  label?: string;
  onChange?: (e: any) => void;
  option?: any;
  inputProps?: any;
  multiple?: any;
  input?: any;
  MenuProps?: any;
  renderValue?: any;
  selected?: any;
  name?: string;
  error?: any;
  helpertext?: any;
  helperText?: any;
  sx?: any;
  style?: any;
  variant?: "standard" | "outlined" | "filled";
  disabled?: any;
  defaultValue?: any;
  labelId?: any;
}

export const SelectField: React.FC<selectProps> = (props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        width: "100%",
        mt: 1, // ensures spacing below TextField
      }}
    >
<Select
  {...props}
  MenuProps={{
    PaperProps: {
      style: {
        maxHeight: 220, // limit dropdown height
        width: "auto",
      },
    },
    disableScrollLock: true, 
  }}
  sx={{
    minHeight: { xs: 38, sm: 42, md: 46 },
    fontSize: { xs: "0.85rem", sm: "0.9rem", md: "1rem" },
    borderRadius: 1,
    backgroundColor: "background.paper",
    ...props.sx,
  }}
>
  {(props.option ?? []).map((elm: any, i: number) => 
  {
    return(
    <MenuItem key={i} value={String(elm.value ?? elm.id)}>
      {elm.name || elm.title}
    </MenuItem>
  )})}
</Select>


      {props?.helpertext && (
        <FormHelperText style={{ color: color.Error_Text }}>
          {props.helpertext}
        </FormHelperText>
      )}
    </Box>
  );
};
